import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { UIKitModule } from '@vendasta/uikit';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatListModule } from '@angular/material/list';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { LocalSEOTableComponent } from './local-seo-table.component';
import { DeltaComponent } from '../delta/delta.component';
import { LexiconModule } from '@galaxy/lexicon';
import en from '../assets/i18n/en_devel.json';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { LocalSEOGridComponent } from './local-seo-grid/local-seo-grid.component';
import { LocalSEOGraphComponent } from './local-seo-graph/local-seo-graph.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GoogleMapsModule } from '@angular/google-maps';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
@NgModule({
  declarations: [LocalSEOTableComponent, LocalSEOGridComponent, LocalSEOGraphComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatCardModule,
    MatIconModule,
    UIKitModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDividerModule,
    GalaxyEmptyStateModule,
    MatListModule,
    GalaxyLoadingSpinnerModule,
    DeltaComponent,
    LexiconModule.forChild({
      componentName: 'common/local-seo',
      baseTranslation: en,
    }),
    DeltaComponent,
    MatButtonToggleModule,
    DeltaComponent,
    MatButtonModule,
    NgxChartsModule,
    GoogleMapsModule,
    GalaxyBadgeModule,
    MatSlideToggleModule,
  ],
  exports: [LocalSEOTableComponent],
})
export class LocalSEOTableModule {}
